// 中文语言包
/**
 * common 公共的内容
 * router 路由用到
 * components 公用组件的内容
 * tableColumn
 * form 表单相关标签/placeholder/options
 * formRules 规则
 * msg
 * error
 * fields 监测属性
 * units 单位
 * dync 动态参数集合
 *...其他也面用到的翻译
 */
module.exports = {
  // 公共的内容
  common: {
    enable: 'Enable',
    notEnabled: 'Not Enabled',
    allSelect: 'Select all',
    cancelSelect: 'Unselect all',
    selectAll: 'Select all',
    passwordAgainPlacecholder: 'Please enter the password again',
    selectProject: 'Select project',
    signOut: 'Sign out',
    loading: 'loading...',
    reset: 'Reset',
    next: 'Next',
    submit: 'Submit',
    total: 'Total',
    corporation: 'Corporation',
    project: 'Project',
    structure: 'Structure',
    measuringPoint: 'Measuring Point',
    device: 'Device',
    measurement: 'Measurement',
    deviceType1: 'Device category',
    search: 'Search',
    chartLoading: 'Generating chart',
    exportData: 'Export data',
    exportReport: 'Export report',
    pleaseSelect: 'Please select ',
    pleaseInput: 'Please input',
    all: 'All',
    seeDetails: 'View details',
    delete: 'Delete',
    cancel: 'Cancel',
    deleteConfig: 'Delete Config',
    longitude: 'longitude',
    latitude: 'latitude',
    offsetE: 'E offset(m)',
    offsetN: 'N offset(m)',
    offsetU: 'U offset(m)',
    offsetTime: 'Offset Time',
    offsetNo: 'No Offset',
    edit: 'Edit',
    edit1: 'Edit',
    tableLoading: 'loading...',
    operationCanceled: 'Operation canceled',
    theme: 'Theme',
    networkID: 'Network ID',
    operating: 'Operating',
    create: 'Create',
    update: 'Update',
    save: 'Save',
    putPointSucess: 'Saved successfully! {located} measured points, {unlocated} unlocated points',
    sum: 'Sum',
    success: 'Success',
    fail: 'Fail',
    collectorChannelConfig: {
      label: 'Protocol configuration',
      col1: 'Channel number',
      col1Pre: 'Channel ',
      col2: 'Protocol',
      col2Placeholder: 'Select protocol',
    },
    confirm: 'Confirm',
    verificationCode: 'Verification Code',
    user: 'User',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    email: 'Email',
    remarks: 'Remarks',
    mobile: 'Moblie Phone',
    timeBase: 'YYYY/MM/DD HH:mm:ss',
    tips: 'Tips',
    legend: 'Legend',
    layer: 'Layer',
    waitData: 'Waiting data...',

    startTest: 'Start test',
    pauseTest: 'Pause test',
    xyView: 'XY view',
    xzView: 'XZ view',
    yzView: 'YZ view',
    threeDChart: '3D chart',

    startVerify: 'Start verify',
    pauseVerify: 'Pause verify',
    deviceNodeReady: 'Nodes of the equipment installed in place',
    ivt: 'Installation verification',
    ivtTitle: 'Installation feedback diagram',
    ivtXAxis: 'Installation Angle (degree)',
    ivtYAxis: 'Depth (m)',
    ivtUninstall: 'Not installed',
    ivtInstalled: 'installed',
    ivtThreshold: 'Installation threshold',

    readTime: 'Read time',

    originalReferencePoint: 'Original reference point',

    remoteSensing: 'Remote-sensing',
    topographic: 'Topographic',
    traffic: 'Traffic',
    dataEmpty: 'Data is empty',
    projectDeviceResearch: 'Equipment certificate Form',
    editThreshold: 'Edit threshold',
    initCollection: 'Init Collection',
    fullscreen: 'Full screen',
    exitFullscreen: 'Exit full screen',
    waitingDev: 'Under development, stay tuned!',
  },
  // 路由
  router: {
    Home: 'Home',
    managementConsole: 'Management console',
    projects: 'Projects',
    ProjectIndex: 'Projects',
    monitoringData: 'Monitoring data',
    commonMonitor: 'Common Measurement',
    groupMonitor: 'Group Measurement',
    alarmRecord: 'Alarm Record',
    reports: 'Reports',
    exportReport: 'Export Report',
    downloadReport: 'Download Report',
    projectConsole: 'Project management',
    deviceConsole: 'Device',
    systemManagement: 'System',
    corporateInformation: 'Enterprise',
    corporationConsole: 'Enterprise',
    contacts: 'Contacts Manager',
    contact: 'Contacts',
    config: '坐标系管理',
    accountManagement: 'Account',
    userConsole: 'Account',
    rolePermissions: 'Permissions',
    roleConsole: 'Permissions',
    groupManagement: 'Group',
    userGroupConsole: 'Group',
    collapseSidebar: 'Collapse',
    profile: 'Personal center',
    alerts: 'Alarm Record',
    pushStrategy: 'Push Strategy',
    pushStrategyConsole: 'Push Strategy',
    CommandDebug: 'Command Debug',
    operationLog: 'Operation logs',
  },
  // 公用组件的内容
  components: {
    timingDiagram: 'Timing diagram',
    deleteObject: 'Delete object',
    bimUploadStatusFinishLabel: 'Uploaded',
    bimUploadStatusFinishLink: 'Initiate conversion',
    bimUploadStatusConvertingLabel: 'Converting',
    bimUploadStatusConvertingLink: 'Update progress',
    bimUploadDeleteSourceFiles: 'Delete source files',
    bimConvertSuccess: 'Success',

    imgLocationInputFromTop: 'From top',
    imgLocationInputFromLeft: 'From left',
    imgLocationInputPictureAnnotation: 'Picture annotation',
    imgLocationInputPoint: 'Mark point',

    locatePlaceholder: 'Enter the address to locate',
    markedHere: 'Marked here',

    formLabel: 'Associated measuring point',
    connected: 'Connected',
    unConnected: 'Unlinked measuring point',
    associatedPoint: 'Associated measuring point',
    addPoint: 'Add tag',
    deletePoint: 'Delete tag',
    savePoint: 'Save',

    // ConfInput组件
    confInput: {
      ids: {
      // 配置网络
        TCP: '4G',
        // 配置采集策略
        CommandCollect: 'Command Collect',
        UploadCollect: 'Upload Collect',
        NoCollect: 'No Collect',
      },
      // 配置网络
      networkConf: {
        register: 'Register',
      },
      // 配置采集策略
      collectConf: {
        interval: {
          label: 'Collection interval',
        },
        start: 'Start time',
        end: 'End time',
        retry: {
          label: 'Retries',
          unit: 'frequency',
        },
        delay: {
          label: 'Retry interval',
          unit: 'second',
        },
      },
    },
  },
  tableColumn: {
    bimUploadName: 'File name',
    bimUploadTranslateStatus: 'Transition state',
    time: 'Collect time',
    node: 'First node',
    voltage: 'Voltage(V)',
    temperature: 'Temperature(°C)',
    alertTime: 'Alarm time',
    type: 'Type',
    level: 'Level',
    status: 'State',
    alarmItem: 'Alarm item',
    alarmValue: 'Alarm value',
    alarmReason: 'Alarm reason',
    alarmLocation: 'Alarm location',
    reportTime: 'Report time',
    name: 'Name',
    alertType: 'Alarm type',
    structureId: 'Focus structures',
    alertLevel: 'Alarm level',
    mobileList: 'SMS list',
    mobileConfirmList: 'Danger Confirmation SMS list',
    mobileVoiceListField: 'SMS Voice Notice list',
    emailList: 'E-mail List',
    enable: 'Enabled',
    memberName: 'Account',
    displayName: 'Nickname',
    memberStatus: 'Active state',
    card: 'Device configuration',
    card3: 'Location configuration',
    card4: 'Offset Config',
    manufacturer: 'Manufacturers',
    deviceName: 'Device name',
    deviceModel: 'Device type',
    serialNumber: 'Sn',
    fileName: 'data file name',
    fileSize: 'data file size',
    fileLastTime: 'data file update time',
    isMounted: 'Associated states',
    card2: 'Channel configuration',
    accType: 'Account type',
    roleName: 'Role name',
    roleNote: 'Role note',
    groupName: 'Group name',
    groupNote: 'Group note',
    pushType: 'Push strategy',
    pushEnable: 'Enable',
    pushInterval: 'Interval',
    ruleNote: 'Description',
    pushUrl: 'Url',
    jobName: 'job name',
    jobOptions: 'job options',
    jobNextRunAt: 'next time',
    userRole: 'User role',
    config: 'Config',
    xOffset: 'offset X',
    yOffset: 'offset Y',
    zOffset: 'offset Z',
    hConvergence: 'hConvergence',
    vConvergence: 'vConvergence',
    archSettlement: 'Arch Settlement',
    roadbedSettlement: 'Roadbed Settlement',
    differentialSettlement: 'Differential Settlement',
    chord: 'Chord',
    chordDiff: 'Chord Change',
  },
  // 表单相关标签/placeholder/options
  form: {
    structureName: 'Structure name',
    structureAddress: 'Structure address',
    displayMode: 'Display',
    structurePicture: 'picture',
    displayTypeOptions: {
      MAP: 'Map display',
      IMG: 'Graphic display',
      BIM: 'BIM model display',
    },
    measurementPointType: 'Type',
    measuringPointNumber: 'Sn',
    measuringPointImage: 'Picture',
    monitoringEquipment: 'Monitoring device',
    collectionEquipment: 'Collection device',
    transmissionDevice: 'Transmission device',
    collectMode: 'Collect Mode',
    uploadCollect: 'Upload Collect',
    commandCollect: 'Command Collect',
    noCollect: 'No Need Collect',
    selectTestType: 'Select test type',
    testOptions: {
      'adm-test': 'ADM Test',
      'adm-install-test': 'ADM Press Installation Test',
      'sdm-test': 'SDM Test',
      'sdmx-test': 'SDMX Test',
      'sdmpro-test': 'SDMPRO Test',
      'gps-sdmpro-test': 'SDMPRO GPS Test',
    },

    pointPlaceholder: 'Measuring point',
    timeLimit: 'Time',
    intervals: 'Interval',
    measurementType: 'Value type', // TODO
    measurementTypeOptions: {
      observations: 'Observation value',
      changeValue: 'Deformation value',
    },
    gnssType: 'Result type', // TODO
    gnssTypeOptions: {
      GNSS: 'GNSS result',
      GNSS2: 'GNSS2 result',
      GNSS3: 'GNSS3 result',
      GNSS4: 'GNSS4 result',
      GNSS5: 'GNSS5 result',
    },
    ObField: 'Observational properties',
    ObNode: 'Observation nodes',
    pointNumber: 'Measuring points', // TODO
    enterpriseID: 'Enterprise ID',
    deviceType: 'Device type',
    manufacturer: 'Manufacturers',
    deviceName: 'Device name',
    deviceModel: 'Device model',
    serialNumber: 'Serial number',
    isSensor: 'isSensor',
    withAcquisitionFunction: 'With Collect function',
    withTransmissionFunction: 'With transmission function',
    numberOfChannels: 'Channel number',
    networkConfiguration: 'Network configuration',
    collectorType: 'Collector type',
    companyName: 'Enterprise name',
    companyNamePlacecholder: 'Please enter the business name',
    logo: 'Logo',
    favicon: 'Favicon',
    platformName: 'Platform name',
    platformNamePlacecholder: 'Please enter the platform name',
    address: 'Address',
    addressPlacecholder: 'Please enter the address',
    slogan: 'Slogan',
    sloganPlacecholder: 'Please enter slogan',
    domainName: 'Domain',
    domainNamePlacecholder: 'Please enter a domain',
    copyrightInformation: 'Copyright',
    copyrightInformationPlacecholder: 'Please enter copyright',
    loginPageBackground: 'Login page background',
    WechatAppletLoginPageBackground: 'Applet login page background',
    WechatAppletBasePageBackground: 'Applet home page picture',
    WechatAppletAboutIntroduce: 'Applet about us',
    WechatAppletContacts: 'Applet contacts',
    WechatAppletContactsPhone: 'Applet contact phone',
    WechatAppletContactsMailbox: 'Applet contact email',
    remarkInformation: 'Remark',
    displayName: 'Nickname',
    roles: 'Roles',
    userGroups: 'Groups',
    rolePlacecholder: 'Select roles',
    groupPlaceholder: 'Select groups',
    activeStatusOptions: {
      true: 'Disable',
      false: 'Activity',
    },
    groupName: 'Group name',
    groupNote: 'Group note',
    groupRoles: 'Roles',
    groupUsers: 'Members',
    rolesPlaceholder: 'Select roles',
    usersPlaceholder: 'Select members',
    avatar: 'Avatar',
    namePlacecholder: 'Please enter the account',
    displayNamePlacecholder: 'Please enter a nickname',
    mobilePlacecholder: 'Please enter the mobile phone',
    emailPlacecholder: 'Please enter the email',
    oldPassword: 'Old password',
    newPassword: 'New password',
    newPasswordConfirmation: 'Confirm new password',
    oldPasswordPlaceholder: 'Please enter the old password',
    newPasswordPlaceholder: 'Please enter the new password',
    confirmationPlaceholder: 'Please enter new password again',
    pushtype: 'Push type',
    pushurl: 'Push url',
    pushinterval: 'Interval',
    pushenable: 'Enable',
    pushdes: 'Description ',
    pushmeasuringPointIds: 'Measuring points',
    badNodes: 'Hide node',
    hiddenNodes: 'Failure node',
    antiSettle: 'Sink correction',
    isIndep: 'Independent Coordinate',
    coorSystem: 'Coordinate System',
    profileChart1LMetric: 'Horizontal Axis (Left of the Profile Draw)',
    profileChart1RMetric: 'Horizontal Axis (Right of the Profile Draw)',
    profileChart1LNoteL: 'Mark ofleft region (Left of the Profile Draw)',
    profileChart1LNoteR: 'Mark of the right region (Left of the Profile Draw)',
    profileChart1RNoteL: 'Mark of the left region(Right of the Profile Draw)',
    profileChart1RNoteR: 'Mark of the right region (Right of the Profile Draw)',
    profileChart3CoorSystem: 'Coordinate System of Trajectories',
    handCoorSystemOptionsR: 'Right-Hand System',
    handCoorSystemOptionsL: 'Left-Hand System',
    profileChart3NoteL: 'Mark of left region(Trajectories Draw)',
    profileChart3NoteR: 'Mark of right region(Trajectories Draw)',
    formulaType: 'Gormula type',
    formulaTypeSystem: 'System formula',
    formulaTypeCustom: 'Customized formula',
    sysFormula: 'Select formula',
    insideDiameter: 'Inside diameter',
    insideDiameterP: 'Please enter inside diameter, unit mm',
    selectMeasuringPoint: 'Select measure point',
    slaveMeasuringPoint: 'slave point',
    rdmTime: 'time',
    rdmFixOptions: {
      unfix: 'unfix',
      fix: 'fix',
    },
    pointPosition: 'point position',
    sectionChord: 'chord',
  },
  formRules: {
    name: 'Full Name',
    stringRequire: 'Can\'t be empty, please enter',
    numberRequire: 'Can\'t be empty, please enter a value',
    length6to20:'Please limit to 6 and 20 characters',
    length20: 'Please limit to 20 characters',
    length50: 'Please limit to 50 characters',
    mobileRequire: 'Phone required',
    mobile: 'Phone format is incorrect',
    email: 'E-mail format is incorrect',
    passwordRequire: 'Password required',
    passwordLength6: 'Password length less than 6 digits',
    domainRequire: 'Domain required',
    contactName: 'Contact Name required',
    domain: 'Incorrect domain name format',
    ip: 'Incorrect IP format',
    point: 'Mount point cannot be empty',
    collectorChannel: 'Incorrect acquisition channel parameter format',
    corporationName: 'Enterprise name required',
    corporationTitle: 'Platform Title required',
    userGroupName: 'Group name required',
    roleRuleName: 'Role name required',
    projectName: 'Project name required',
    projectAddress: 'Please enter the project address',
    deviceMeasurement: 'Measurement type required',
    deviceCategory: 'Device category required',
    deviceType: 'Device type required',
    deviceManufacturer: 'Manufacturer required',
    deviceName: 'Device name required',
    deviceModel: 'Device model required',
    deviceModelPreg: 'Device model:',
    deviceSncode: 'Serial number required',
    deviceCollectorType: 'Collector type required',
    deviceCoorSystem: 'Please select the coordinate label',
    deviceProfileChart1LMetric: 'Please select',
    deviceProfileChart1RMetric: 'Please select',
    zrzybIp: 'IP cannot be empty',
    zrzybPort: 'port number cannot be empty',
    zrzybDeviceId: 'MQTT USERNAME cannot be empty',
    zrzybDeviceKey: 'MQTT PASSWORD cannot be empty',
    zrzybDeviceNumber: 'monitoring serial number cannot be empty',
    zrzybDeviceNumberNode: 'The number of monitoring serial numbers of the equipment is inconsistent with the number of nodes, please check',
    zrzybDeviceNumberNull: 'Monitoring serial number cannot be empty or duplicate, please check',
    zrzybIsPush: 'please select whether to enable push',
    deviceTypeRule: 'Please select the device category',
    mpAttrType: 'Please select indicator',
    mpAttrName: 'Indicator name required',
    mpAttrDeviceId: 'Associated device required',
    mpAttrInterval: 'Measurement interval required',
    mpName: 'Measuring point name required',
    mpStructureId: 'Please select structure',
    mpMeasuringDeviceId: 'Please select measuring device',
    mpDtuId: 'Please select transmission device',
    structureName: 'Structure name required',
    structureType: 'Structure type required',
    bimName: 'BIM name required',
    bimAddress: 'BIM url required',
    measurement: 'Please select the monitoring type',
    formulaType: 'Select the formula type',
    computedField: 'Select the conversion attribute',
    formula: 'Formula required',
    sysFormula: 'System formula required',
    thresholdRule: 'Threshold interval format error',
    thresholdField: 'Select a monitoring attribute',
    thresholdType: 'Select the measurement type',
    thresholdVoltage: 'Enter the voltage threshold',
    thresholdLost: 'Enter the loss tolerance',
    alertRuleType: 'Select the alarm type',
    alertRuleMobileList: 'Irregular mobile phone number in SMS list',
    alertRuleEmailList: 'Irregular mailboxes in the mailing list',
    projectId: 'Please select project',
    pushStrategyType: 'Please select the push type',
    pushStrategyUrl: 'Please enter the push interface',
    pushStrategyInterval: 'Please select push interval',
    measuringPointIds: 'Select the measuring point',

    structureGnsstaskName: 'Please enter the Task Name',
    structureGnssAgreementCode: 'Please select an Protocol',
    structureGnssBaseStation: 'Please select an BaseStation',
    structureGnssFilteringTime: 'Please enter the Filtering Time',
    structureGnssFtTiNoZero: 'Filtering duration and task interval cannot be 0',
    structureGnssTaskInterval: 'Please enter the Task Interval',
    structureSwitch: 'Switching structure',
    pointFilter: 'Filter the measuring point',
    sncodeExist1: 'The serial number ',
    sncodeExist2: ' has been used. If you have any questions, please contact your administrator',
    registerExist1: 'The network identifier ',
    registerExist2: ' has been used. If you have any questions, please contact your administrator',
  },

  msg: {
    1: 'Will the data collected by {time} be used as the initial value of the current measurement point?',
    2: 'Do you want to delete data collected by {time}?',
    3: 'This operation will update the alarm status to "{status}" and cannot be changed again. Please confirm?',

    4: 'This action will permanently delete the policy. Do you want to continue?',
    5: 'Undeleted',
    6: 'Are you sure to modify the policy?',
    7: 'Unmodified',

    8: 'Voltage threshold, when the device voltage is lower than the set value, it will trigger the device health alarm (undervoltage).',
    9: 'Loss tolerance, collection loss with continuous setting times will trigger the device health alarm (collection anomaly)',
    10: 'will cancel {name} ?',
    11: 'formula of {count} monitoring devices were successfully updated ',
    12: 'Trajectory updated',
    13: 'Are you sure to turn on monitoring?',
    14: 'Are you sure to turn off monitoring?',
    50: 'Are you sure you want to delete this solving task?',
    title1: 'Operating hints',
    msg1: 'Save the detection point marking operation',
    associatedMeasuringPoint: 'There are marks for unassociated detection points. Please associate them all',
    createThresholdSucess: 'Successfully created {createCount} threshold configuration for measurement fields, and updated {updateCount} threshold configuration for measurement fields',
    bimUpload1: 'Drag the file here, or',
    bimUpload2: 'Click on the upload',
    bimUpload3: 'Supports file formats RVT, RFA, DWG, DXF, SKP, IFC, DGN, OBJ, STL, 3DS, DAE, PLY, IGMS, ZIP, FBX, DWF, NWD, OSGBZIP size limit of 10240M',
    bimUpload4: 'Please confirm to delete the BIM model!',
    bimUpload5: 'Failed to upload source file',
    bimUpload6: 'Source file upload failed',
    repeatPhone: 'Phone number already exists',
  },
  error: {
    2: 'The array displacement meter associated with the current measuring point has not updated the node number ',
    4: 'The current formula contains illegal input, please press the prompt to input ',
    5: 'The current formula is incomplete...',
    6: 'The category of detection point associated monitoring device is incorrect ',
    7: 'Loading structure option failed ',
    8: 'Loading monitor type option failed ',
    9: 'Failed to load device category ',
    10: 'Failed to load monitoring field ',
    11: 'Failed to load detection option ',
    12: 'Health thresholds of {count} monitoring devices were successfully updated ',
    13: 'Please upload the picture file!',
    14: 'Upload image size cannot exceed 200KB!',
    15: 'Detection point information error, unable to obtain the detection point trajectory',
    lessPointToast: 'Select one point and query',
    noMeasuringDevice: 'Please standardize the operation and re query or refresh the page',
    noInitCollection: 'No InitCollection',
    noCollections: 'No Collections Found',
    rdmNoConfig: 'RDM config invalid',
    noEqualToExpectedNodeCount: 'node count ({nodeCount}) is not equal to expected ({expectedNodeCount}), please check and update',
    deviceDisConnect: 'Please operate after the device is networked',
    gnssBaseStationNoData: 'GNSS reference station has no monitoring data',
    sgbjStr: 'Please fill in the alarm content',
    sgbjInterval: 'Please fill in the interval of alarms',
  },
  // 监测属性
  fields: {
    voltage: 'Voltage',
    temperature: 'Temperature',
    x: 'x',
    y: 'y',
    z: 'z',
    azi: 'Azi',
    gx: 'gx',
    gy: 'gy',
    gz: 'gz',
    anglex: 'Anglex',
    angley: 'Angley',
    anglez: 'Anglez',
    angleh: 'Angleh',
    anglev: 'Anglev',
    slantdist: 'Slantdist',
    tiltx: 'Tiltx',
    tilty: 'Tilty',
    e: 'e',
    n: 'n',
    u: 'u',
    ve: 'East coordinate daily deformation rate',
    arctanE: 'East direction Tangential angle',
    vn: 'North coordinate daily deformation rate',
    arctanN: 'North direction Tangential angle',
    vu: 'Vertical coordinate daily deformation rate',
    arctanU: 'Vertical direction Tangential angle',
    xyDisplacement: '2D Displacement',
    xyDisplacement2: '2D Distance',
    xyzDisplacement: '3D Displacement',
    xyzDisplacement2: '3D Distance',
    differenceAge: 'DifferenceAge', // 差分期龄
    idmD: 'IdmD', // 图像位移测量仪属性
    idmS: 'IdmS',
    f: 'f',
    t: 't',
    i: 'i',
    liquidlevel: 'Liquid level',
    deltah: 'deltah',
    settle: 'settle',
    displacement: 'Displacement',
    mod: 'Mod',
    pressure: 'Pressure',
    waterlevel: 'Waterlevel',
    waterlevel1: 'Waterlevel',
    crack: 'Crack',
    humidy: 'humidy',
    steel: 'Steel', // 钢筋计
    strain: 'Strain',
    stress: 'Stress',
    custom: 'Custom',
    dataLost: 'Data lost',
    dataRepeat: 'Data Repeat',
    lowVoltage: 'Low voltage',
    axialforce: 'axial force',
    soilpressure: 'soil pressure',
    pt: 'total precipitation(sensor value)',
    pd: 'day precipitation',
    pj: 'precipitation',
    ph: 'hourly precipitation',
    p24: 'rainfall in the first 0-24 hours',
    p48: 'rainfall in the first 24-48 hours',
    p72: 'rainfall in the first 48-72 hours',
    pc: 'rainfall in the previous 3 days',
    pcc: 'rainfall value of the first 0-24 hours * 1 + rainfall value of the first 24-48 hours * 0.8 + rainfall value of the first 48-72 hours * 0.5',
    rainfall: 'rainfall',
    winPressure: 'Wind Pressure',
    windDir: 'Wind Direction',
    windSpeed: 'Wind Speed',
    flowrate: 'flowrate',
    depth: 'depth',
    a: 'A',
    a0: 'A0',
    a180: 'A180',
    b: 'B',
    b0: 'B0',
    b180: 'B180',
    angle: 'Angle',
    angle0: 'PASS0 Angle',
    angle180: 'PASS180 Angle',
    xOffset: 'offset X',
    yOffset: 'offset Y',
    zOffset: 'offset Z',
    hConvergence: 'hConvergence',
    vConvergence: 'vConvergence',
    archSettlement: 'archSettlement',
    roadbedSettlement: 'roadbedSettlement',
    differentialSettlement: 'differentialSettlement',
    chord: 'chord',
    chordDiff: 'chordDiff',
  },
  // 单位
  units: {
    v: 'v',
    times: 'times',
    m: 'm',
    mm: 'mm',
    frequency: 'frequency',
    hour: 'hour',
    minute: 'minute',
    second: 'second',
    deg: 'degree',
  },
  // 动态参数集合
  dync: {
    accType: {
      System: 'System account',
      Admin: 'Enterprise account',
      Normal: 'Ordinary account',
    },
    chartType: {
      overview: 'Latest status',
      'adm-chart': 'Data Charts',
      'tdm-chart': 'Data Charts',
      'common-chart': 'Data Charts',
      'gnss-chart': 'Data Charts',
      'gnss-realtime-chart': 'GNSS Realtime Charts',
      'adm-data': 'Data Tables',
      'common-data': 'Data Tables',
      camera: 'Camera View',
      deviceTrajectory: 'Device Trajectory',
      SectionOffset: 'Section Offset',
      SectionConvergence: 'Section Convergence',
      SectionSettlement: 'Section Settlement',
      SectionChord: 'Section Chord',
    },
    chartTypeOptions: {
      profile: 'Profile',
      componentMap: 'Component map',
      orientationMap: 'Orientation map',
      ThreeDimensionalMap: 'Three-dimensional map',
      horizontalChart: 'Horizontal Chart',
      circularChart: 'Circular Chart',
      rdmPipeChart: 'Pipe Chart',
      rdmChangeChart: 'Change Chart',
      rdmAccChangeChart: 'Acc Change Chart',
      rdmFixRChart: 'FixR Chart',
      rdmTempChart: 'Temperature Chart',
    },
    devicetype: {
      Measuring: 'Measuring Device',
      Collector: 'Collector',
      DTU: 'DTU',
    },
    collectorType: {
      ADM: 'ADM',
      HDA2: 'HDA2',
      HDA3: 'HDA3',
      SDM: 'SDM',
    },
    structureType: {
      Bridge: 'Bridge',
      FoundationPit: 'Foundation pit',
      Slope: 'Slope',
      Dam: 'Dam',
      Tunnel: 'Tunnel',
      Tailings: 'Mine',
      Building: 'Building',
      Tower: 'Tower',
      SpecialEquipment: 'Special Equipment',
      WeatherStation: 'Weather station',
      PipeNetwork: 'Pipe',
    },
    measuringType: {
      ALL: 'ALL',
      DeepDisplacement: 'Deep Displacement',
      SurfaceDisplacement: 'Surface Displacement',
      Waterlevel: 'Water level',
      Waterlevel1: 'Water level',
      Tilt: 'Tilt',
      Vibration: 'Vibration',
      Crack: 'Crack',
      Track: 'Trajectory',
      DBCJ: 'Settlement',
      ZCYL: 'Stress-Strain',
      AxialForce: 'Axial Force',
      StructuralDeformation: 'Structural Deformation',
      Camera: 'Video Monitor',
      SGBJ: 'SoundAndLightAlarm',
      Temperature: 'Temperature',
      Rainfall: 'Rainfall',
      Flow: 'flow',
      Moisture: 'Moisture',
      SoilPressure: 'Soil Pressure',
      SoilMoisture: 'Soil Moisture',
      Displacement: 'Displacement',
      WindSpeed: 'Wind Speed',
      WindDirection: 'Wind Direction',
      SlopeVibration: 'Slope Vibration',
      HorizontalTilt: 'Tilt Horizontally',
      SupportingStructureDeformation: 'Deformation of supporting structure',
      GNSSReferenceStation: 'GNSS Base',
      GNSSMonitoringStation: 'GNSS Monitor',
      GroundwaterLevel: 'Groundwater Level',
      PhreaticLine: 'Phreatic Level',
      ClearanceConvergence: 'Clearance Convergence',
      PoreWaterPressure: 'Pore-Water Presser',
      Deflection: 'Deflection',
      DebrisFlow: 'DebrisFlow',
      SupportingAxialForce: 'Supporting Axial Force',
      AnchorForce: 'Anchor Force',
    },
    deviceCategory: {
      ADM: 'ADM',
      HDA2: 'HDA2',
      HDA3: 'HDA3',
      HDA_HS: 'HDA_HS',
      Crack: 'Crack',
      SDM: 'SDM',
      SDMX: 'SDMX',
      SDMPRO: 'SDMPRO',
      TDM: 'TDM',
      HSL: 'HydrostaticLevel',
      STRAIN: 'STRAIN',
      Steel: 'Steel',
      Anchor: 'Anchor',
      AFM: 'AFM',
      SPM: 'SPM',
      SHM: 'SHM',
      Station: 'Station',
      GNSS: 'GNSS',
      Camera: 'Camera',
      SGBJ: 'SoundAndLightAlarm',
      RDM: 'RDM',
      IDM: 'IDM',
      Rain: 'rainguage',
      Flow: 'flowmeter',
    },
    alarmStatus: {
      Pending: 'Pending',
      Notice: 'Notice',
      Confirm: 'Confirm',
      ConfirmNotice: 'ConfirmNotice',
      FalseAlarm: 'False alarm',
      Restore: 'Restore',
    },
    timeOptions: {
      hour1: 'Last hour',
      day1: 'Last Day',
      week1: 'Last week',
      month1: 'Last month',
      halfYear: 'Last six months',
      year1: 'Last year',
      thisHour1: 'This hour',
      thisDay1: 'This day',
      thisWeek1: 'This week',
      thisMonth1: 'This month',
      thisHalfYear: 'This halfYear',
      thisYear1: 'This year',
    },
    intervalsText: {
      seconds0: 'No Intervals',
      seconds1: '1 seconds',
      seconds5: '5 seconds',
      seconds10: '10 seconds',
      seconds30: '30 seconds',
      minute1: '1 minute',
      minute2: '2 minute',
      minute5: '5 minute',
      minute10: '10 minute',
      minute15: '15 minute',
      minute30: '30 minute',
      hour1: '1 hour',
      hour2: '2 hour',
      hour6: '6 hour',
      hour12: '12 hour',
      day1: '1 day',
      day2: '2 day',
      day5: '5 day',
      day7: '7 day',
      day10: '10 day',
      day20: '20 day',
      day30: '30 day',
    },
    tScope: {
      Corporation: 'Enterprise',
      User: 'Account',
      UserGroup: 'Grouping',
      Role: 'Role',
      Project: 'Project',
      Structure: 'Structure',
      MeasuringPoint: 'Measuring Point',
      Device: 'Device',
      Report: 'Report',
      AlertRule: 'Alert Rule',
      PushRule: 'Data Push',
      Alert: 'Alert',
    },
    tAction: {
      Create: 'Create',
      Delete: 'Delete',
      Retrieve: 'Retrieve',
      Update: 'Update',
    },
    tDevType: {
      Measuring: 'Measuring',
      Collector: 'Collector',
      DTU: 'DTU',
    },
  },

  // 登录页的内容
  login: {
    login: 'Sign in',
    register: 'Register',
    username: 'Username',
    zh: '简体中文',
    en: 'English',
    zhTW: '繁體中文',
    rememberMe: 'Stay signed in',
    forgetPassword: 'Forget password',
    loading: 'Sign in...',
    slogan: 'Professional because of concentration',
    start: 'Start',
    accountInformation: 'Account',
    companyInformation: 'Company',
    ending: 'Complete',
    phone: 'Moblie Phone',
    domain: 'Domain',
    companyName: 'Enterprise name',
    cloudPlatformTitle: 'Platform name',
    copyrightInformation: 'Copyright',
    previous: 'Previous',
    loginPage: 'Sign in',
    backRegisterPage: 'Back register',
    verificationCodePlaceholder: 'Please enter the verification code',
    verifySvgCodePlaceholder: 'Please enter the picture verification code',
    verifyPhoneCodePlaceholder: 'Please enter the phone verification code',
    usernamePlaceholder: 'Please enter the Username',
    passwordPlaceholder: 'Please enter the Password',
    validatePasswordDifferent: 'Two passwords are different',
    resetPsd: 'Reset password',
    verify: 'Verification code',
    verifyPhone: 'Phone verification code', // TODO
    verifySvg: 'Picture verification code', // TODO
    usernameR: 'Username required',
    passwordR: 'Password required',
    phoneR: 'Cell phone number required',
    phoneR2: 'Please fill in the correct cell phone number',
    verifyR: 'Verification code required',
    formR: 'Please complete the form and continue!',
    getVerify: 'Get verification',
    returnLogin: 'Return to the login',
    submit: 'Submit',

    resetSuccessTit: 'Password reset successfully',
    resetSuccessP: 'Reset password successfully, the password will be sent to your phone as a text message.',
  },
  // 首页
  home: {
    projectStatusStatistics: 'Project status',
    amount: 'Amount',
    structureStatus: 'Structural state',
    pointStatus: 'Point status',
    alarmProcessing: 'Alarm processing',
    projectStatus: 'Status',
    projectLevel: ['OK', 'LV.1', 'LV.2', 'LV.3'],
    healthStatusList: ['health', 'low voltage', 'data lost', 'data repeat'],
    healthStatus: {
      health: 'health',
      lowVoltage: 'low voltage',
      dataLost: 'data lost',
      dataRepeat: 'data repeat',
    },
    projectNoExist: 'Project does not exist',
    historyAlarm: 'History alarm',
    projectName: 'project name',
    projectAddress: 'project address',
    structuresTotal: 'structures total',
    pointTotal: 'point total',
    associatedDeviceTotal: 'associated devices total',
    projectInfo: 'Porject information',
    deviceStatus: 'Device status',
    monitoringOverview: 'Monitoring Overview',
    alertStat: 'Alarm status',
    monitoringTableHeader: [
      'Structure',
      'Point',
      // 'SnCode',
      // 'Voltage',
      'Field',
      'Maximum',
      'Current Change',
      'Daily Change Rate',
      'Latest Time',
      'Alarm status',
      'Alarm value',
    ],
    alarmOverview: 'Alarm overview',
    tableHeader: ['Structure', 'Point', 'Alarm'],
    defaultIntroduction: 'The project has not filled in the remarks information.',
    total: 'Total',
    goBack: 'previous page',
  },
  // 检测数据
  monitor: {
    preview: 'Preview',
    createStructure: 'Please create structure',
    selectChartType: 'Select chart type',
    viewNode: 'View node',
    profileChart: 'profile chart',
    FIGTimingMeasuring: 'Measuring point chart',
    timeValueChart: 'time value chart',
    nodeValueChart: 'node value chart',
    nodeTrackChart: 'node track chart',
    admPropChart: 'adm prop chart',
    horizontalChart: 'horizontal chart',
    circularChart: 'circular chart',
    displacementChart: 'displacement chart',
    coordChart: 'coord chart',
    coordChangeChart: 'coord change chart',
    vibrationChart: 'vibration chart',
    GNSSChart: 'GNSS chart',
    pipeChart: 'pipe chart',
    rdmTempChart: 'Current temperature chart',
    rdmFixrChart: 'Current angle chart',
    rdmChangeChart: 'Current change',
    rdmAccChangeChart: 'Cumulative change',
    initTime: 'Initial time',
    initData: 'Initial data',
    componentTrendGraph: 'Component trend graph',
    weight: 'Weight',
    WarningLine: 'Warning line',
    level1: 'Level 1',
    level2: 'Level 2',
    level3: 'Level 3',
    takePictures: 'Take pictures',
    playRecPlayer: 'Exchange Live History',
    more: 'More',
    HistorySnapshot: 'History snapshot',
    RecPlayer: 'Player History',
    LivesPlayer: 'Player Live',
    controlPanel: 'Camera Control panel',
    sgbjControlPanel: 'Sound And Light Alarm Control panel',
    livePlayerLoading: 'Retrieving accessToken...',
    setInitValue: 'Set initial value',
    deleteRecord: 'Delete Record',
    batchDeletion: 'Batch deletion',
    collectionDetails: 'Collection details',
    time: 'time',
    node: 'node',
    elevation: 'elevation',
    depth: 'depth',
    displacement: 'displacement',
    distance: 'distance',
    settlement: 'settlement',
    changeValue: 'change',
    NbyE: 'north by east',
    offset: 'offset',
    A: 'A direction',
    B: 'B direction',
    E: 'East',
    N: 'North',
    NodeOrientationData: 'Node orientation data',
    zoom: 'Zoom',
    showSection: 'Show sections',
    ratioOptions: {
      ratio: 'Ratio',
      adaptive: 'Adaptive',
    },
    profileOptions: {
      view3d: '3D view',
      XYPlaneABPlane: 'XY plane (AB plane)',
      XZPlaneAZPlane: 'XZ plane (AZ plane)',
      YZPlaneBZPlane: 'XY plane (BZ plane)',
    },
    refreshStatus: 'Refresh status',
    caustomReportColumns: 'Custom report columns',
    customColumn: 'Custom column',
    nodePlaceholder: 'Please select a node',
    dialogDeleteTitle: 'Selection of batch deletion method',
    chooseDeleteTime: 'Time period selection for deletion',
    deleteCollotion: 'Please select the collected data to be deleted',
    deleteByTime: 'Delete by time period',
    deleteBySelection: 'Delete by selected',
    chartSetting: 'chart setting',
    xAxis: 'xAxis',
    yAxis: 'yAxis',
    LXAxis: 'Left xAxis',
    RXAxis: 'Right xAxis',
    chartInterval: 'interval',
    max: 'max',
    min: 'min',
    useSetting: 'use',
    common: 'common setting',
    showSymbol: 'show symbol',
    trendPrediction: 'Trend prediction',
    multiIndicatorEarlyWarning: 'Multi-indicator early warning',
    sgbj:{
      status:{
        being:'being',
        waiting:'waiting',
        finish:'finish',
        cancel:'cancel',
      }
    }
  },
  // 报警记录
  alerts: {
    alarmRecord: 'Alarm Record',
    alarmType: 'Alarm type',
    alarmTypeOptions: {
      measuredValueAlarm: 'Measurement alarm',
      equipmentFailure: 'Device failure',
    },
    status: 'Status',
    level: 'Level',
    levelOptions: ['-', 'LV.1', 'LV.2', 'LV.3'],
    alarmDetail: 'Alarm details',
    ConfirmationDanger: 'Danger confirmation',
    riskExclusion: 'Risk exclusion',
    alertDetail: {
      alarmID: 'Alarm ID',
      monitoringAttr: 'Monitoring attributes',
      triggerInterval: 'Trigger interval',
      SMScontent: 'SMS',
      email: 'Email content',
      noticeList: 'Notice list',
      mailingList: 'Mailing list',
      levelAlarm: 'Level alarm',
    },
    reason: {
      dataLost: 'data lost exceeded',
      lowVoltage: 'voltage less than',
      value: 'value in range',
    },
  },
  // 报表下载
  report: {
    exportReport: 'Export Report',
    downloadReport: 'Download Report',
    reportType: 'Report type',
    reportOption: {
      exportData: 'Export data',
      measuringPointReport: 'Measuring point report',
      projectReport: 'Project report',
      projectDeviceResearchReport: 'Project device research report',
    },
    download: 'Download',
    export: 'Export',
    delete: 'delete Report',
    confirmHandler: 'Please confirm your operation again!',
    reportStatus: {
      Done: 'Done',
      Pending: 'Pending',
      Error: 'Error',
    },
    template: 'Report Template',
    ts: {
      project: '项目监测报表',
      day: 'Monitor Report',
      SectionDeformation: 'Section Deformation Report',
    },
    period: 'Report Period',
  },
  // 项目管理
  project: {
    siteMonitoring: 'Site monitoring',
    waitPicture: 'Project picture to be uploaded',
    newProject: 'New Project',
    newSubsidiary: 'New Subsidiary',
    allProject: 'All Project',
    structureType: 'Structure Type',
    measurement: 'Measurement Type',
    structureDetails: 'Structure details',
    pointDetails: 'Measuring point details',
    projectDetails: 'Project details',
    createStructure: 'Create structure',
    createPoint: 'Create measuring point',
    createProject: 'Create project',
    createSubsidiary: 'Create Subsidiary',
    projectInfo: 'Information',
    deviceTopology: 'Device topology',
    convert: 'Conversions',
    alarmThreshold: 'Alarm threshold',
    equipmentHealth: 'Device health',
    alarmManagement: 'Alarm management',
    memberManagement: 'Member management',
    updateRecord: 'Update',
    deleteProject: 'Delete project',
    deleteTitle: 'Delete the project, the structure and measuring point data under the project will be deleted in association, please be careful!',
    projectName: 'Name',
    address: 'Address',
    coordinate: 'Coordinate',
    picture: 'Picture',
    conversionFormulaTitle: 'Configure formula',
    conversionAttributes: 'Attribute',
    conversionFormula: 'Formula',
    conversionFormulaPlaceholder: 'Please enter a valid formula',
    conversionFormulaTip: {
      show: 'Show tips',
      hide: 'Hide tips',
      tip1: 'Please use English input method.',
      tip2: {
        1: 'Can enter numbers',
        2: 'decimal point',
      },
      tip3: {
        1: 'The following operators can be entered: addition, subtraction, multiplication and division',
        2: 'brackets',
        3: 'square',
        4: 'prescribe',
        5: 'sin',
      },
      monitoringAttributes: 'Available monitoring attributes',
      eg: 'eg',
      text: 'Monitoring attribute indicates finding {text} square',
    },
    appPoint: 'In-use point',
    noUsePoint: 'No relevant measurement points',
    configThreshold: 'Config Measurement Threshold',
    monitoringAttributes: 'Monitoring attributes',
    monitoringAttributesPlaceholder: 'Please select a monitoring attribute',
    measurementType: 'Measurement type',
    measurementTypeOptions: {
      1: 'Monitoring value',
      2: 'Change value',
    },
    FirstLevelThreshold: 'level-1 threshold',
    thresholdPlaceholder: 'Please enter threshold range',
    AddThreshold: 'Add level-2 threshold interval',
    secondLevelThreshold: 'level-2 threshold',
    deleteSecondLevelThreshold: 'Delete level-2 threshold',
    addThirdThreshold: 'Add level-3 threshold',
    thirdLevelThreshold: 'level-3 threshold',
    deleteThirdLevelThreshold: 'Delete level-3 threshold',
    addContact: 'Add Contact',
    editContact: 'Edit Contact',
    delContact: 'Delete Contact',
    contact: 'Contact',
    thresholdTip: {
      eg: 'eg',
      tip1: 'Please use the mathematical interval',
      tip2: 'Please use English input method',
      tip3: {
        1: 'Can enter numbers',
        2: 'eecimal point',
        3: 'positive infinity',
        4: 'negative infinity',
      },
      tip4: {
        1: 'Open interval',
        2: 'closed interval',
        3: 'Half-open interval',
      },
      tip5: {
        1: 'Use semicolons for multiple intervals',
        2: 'separate',
      },
      tip6: {
        1: 'express',
        2: 'or',
      },
    },
    configDeviceHealth: 'Config Health Threshold',
    monitorSwitch: 'Monitor Switch',
    voltageThreshold: 'Voltage threshold',
    voltageThresholdPlaceholder: 'Please enter a valid threshold interval',
    lossTolerance: 'Loss tolerance',
    lossTolerancePlaceholder: 'Please enter a valid threshold interval',
    ruleListTitle: 'Rule list',
    configAlarmRule: 'Config Alarm Rules',
    editAlarmRules: 'Edit alarm notification rules',
    deleteAlarmRule: 'Delete alarm rule',
    measuredValueAlarm: 'Measured value alarm',
    levelPlaceholder: 'Please select the alarm level',
    EquipmentAlarm: 'Device alarm',
    mobileListPlaceholder: 'Please select the mobile phone number used to receive the alarm message',
    emailListPlaceholder: 'Please enter the mailbox used to receive alarm emails',
    GnssSolutionConfig: 'GNSS Solution Config',
    ZrzybConfig: 'Internet Of Things Cloud Platform Configuration',
    SDMPROSolutionConfig: 'Inclination Vibrometer Configuration',
    GnssConfig: {
      taskName: {
        label: 'TaskName',
      },
      BaseStation: {
        label: 'Base Station',
      },
      baseType: {
        label: 'BaseStation Type',
      },
      FilteringTime: {
        label: 'Filtering Time',
        unit: 'hour',
      },
      TaskInterval: {
        label: 'Task Interval',
        unit: 'minute',
      },
      taskMode: {
        label: 'Task Mode',
      },
      Smooth: {
        label: 'Is Smooth',
      },
    },
    memberManagementStatusOptions: {
      true: 'Disable',
      false: 'Activity',
    },
    updateMember: 'Update project members',
    at: 'at',
    do: 'doing',
    noRecord: 'No operation record',
    structureInfo: 'Structure information',
    pointDistribution: 'Point distribution',
    deleteStructure: 'Delete structure',
    deleteStructureTitle: 'Delete the structure, the measuring point data under the structure will be deleted in association, please be careful!',
    pointInfo: 'Measuring point',
    deviceInfo: 'Device Info',
    deviceConfiguration: 'Device Configuration',
    deviceTesting: 'Device testing',
    dataPush: 'Data Push',
    zrzybwlwpt: 'Internet of things natural resources platform',
    zrzybwlwptConfig: 'Data push configuration of IOT cloud platform of Ministry of natural resources',
    deleteMeasuringPoint: 'Delete measuring point',
    deleteMeasuringPointTip: 'Delete the measuring point and its associated data, please be careful!s',
    dataMining: 'Data mining',
    other: 'other',
    channel: 'Channel',
    deviceName: 'Device name',
    serialNumber: 'Serial number',
    manufacturer: 'Manufacturer',
    deviceModel: 'Device model',
    model: 'Model',
    channels: 'Channels',
    occupiedChannel: 'Occupied channel',
    networkConfiguration: 'Network Configuration',
    register: 'register',
    thresholdConfiguration: 'Threshold configuration',
    monitoringField: 'Monitoring field',
    calculation: 'Calculation',
    firstInterval: 'First-level threshold interval',
    secondInterval: 'Second-level threshold interval',
    thirdInterval: 'Third-level threshold interval',
    deleteThreshold: 'Delete threshold',
    listeningToData: 'Listening to data',
    clearScreen: 'Clear screen',
    toggleEncode: 'Toggle Encode',
    queryCommands: 'Query commands',
    settingCommands: 'Setting commands',
    otherCommands: 'Other commands',
    operationTips: 'Operation tips',
    tipsThreshold: 'Whether to delete the threshold',
    collectionTime: 'Collection time',
    nodeNum: 'Node number',
    hangJob: 'Hang Job',
    collectConf: 'collect conf',
    processorConf: 'processor conf',
    formulaConf: 'formula conf',
    chartConf: 'chart conf',
    addSlavePoint: 'add slave point',
    removeSlavePoint: 'remove slave point',
    createCommonPoint: 'Create a common detection point',
    createCompositePoint: 'Create a composite measuring point',
    contingencyPlan: 'Contingency plan',
  },
  // 设备中心
  device: {
    equipmentCenter: 'Device Center',
    addDevice: 'Add device',
    editDevice: 'Edit device',
    measuringEquipment: 'Measuring device',
    collectionEquipment: 'Collection device',
    transmissionDevice: 'Transmission device',
    inputPlaceholder: 'Filter name, serial number, model',
    measurementPlaceholder: 'Filter measurement',
    categoryPlaceholder: 'Filter category',
    filterSensor: 'Filter sensor',
    isMountedOptions: {
      true: 'Connected',
      false: 'Disconnect',
    },
    deleteDevice: 'Delete device',
    noConfiguration: 'No need to configure the current device',
    DeviceConfiguration: {
      nodes: 'Nodes',
      segmentLen: 'Node pitch',
      initTwist: 'Installation twist angle',
      markAngle: 'Northeast Angle',
      chartDirection: 'Vertical axis of chart',
      chartDirectionDown: 'Downward is positive (deep installation)',
      chartDirectionUp: 'Upward is positive (overground installation)',
      elevation: 'Elevation',
      version: 'Version',
      zrzybIp: 'HTTP IP',
      zrzybPort: 'HTTP Port',
      zrzybApi: 'HTTP Expand API(Non b\'v)',
      zrzybDeviceId: 'MQTT UserName',
      zrzybDeviceKey: 'MQTT PassWord',
      zrzybDeviceNumber: 'Monitoring serial number',
      zrzybIsPush: 'Open push',
      zrzybMsg: 'If there are multiple serial numbers, please separate them with English commas, for example: 100001,100002,100003',
      // baseStationAgreementCode: 'BaseStation Agreement Type',
      // baseStationIP: 'BaseStation IP',
      // baseStationPort: 'BaseStation Port',
      // baseStationPoint: 'BaseStation Mount Point',
      // baseStationUsername: 'BaseStation Mount UserName',
      // baseStationPassword: 'BaseStation Mount PassWord',
      // baseStationX: 'BaseStation X-direction Outline Coordinates',
      // baseStationY: 'BaseStation Y-direction Outline Coordinates',
      // baseStationZ: 'BaseStation Z-direction Outline Coordinates',
      // baseStationNTRIPLng: 'BaseStation NTRIP Longitude',
      // baseStationNTRIPLat: 'BaseStation NTRIP Latitude',
      // baseStationNTRIPHeight: 'BaseStation NTRIP Height',
      agreementCode: 'Device Access Protocol',
      port: 'Port',
      point: 'Mount Point',
      username: 'Mount UserName',
      password: 'Mount PassWord',
      gnssX: 'X-direction Outline Coordinates',
      gnssY: 'Y-direction Outline Coordinates',
      gnssZ: 'Z-direction Outline Coordinates',
      NTRIPLng: 'NTRIP Longitude',
      NTRIPLat: 'NTRIP Latitude',
      NTRIPHeight: 'NTRIP Height',
      deviceSerial: 'Hik device serial',
      validateCode: 'validate code',
      K: 'K',
      Kt: 'Kt',
      f0: 'f0',
      t0: 't0',
      Kr: 'Kr',
      iMin: 'min current',
      iMax: 'max current',
      fullscale: 'fullscale',
      maxDepth: 'max depth',
      minDepth: 'min depth',
      nodeCount: 'node count',
      mqttKey: 'MQTT-DeviceKey',
      deviceId: 'MQTT-DeviceID',
    },
    log: {
      span1: 'Changed',
      span2: 'to',
    },
    bulkAddDevice: 'Batch import device',
    upload1: 'Select the file',
    upload2: 'Click to download',
    upload3: 'template.xlsx',
    upload4: 'Can only upload <template.xlsx>， and no more than 2MB',
    upload5: 'Select the file and continue',
    deviceNum: 'successNum：',
    failRow: 'Failed rows in Excel：',
  },
  // 设置
  setting: {
    updateCompleted: 'Update completed',
    createAccount: 'Create account',
    editAccount: 'Edit account',
    deleteAccount: 'Delete account',
    roleTitle: 'Role management',
    creatingRole: 'Creating role',
    deleteRole: 'Delete role',
    editRole: 'Edit role',
    assignPermissions: 'Assign permissions',
    accountGroup: 'Account Group',
    createGroup: 'Create Group',
    editGroup: 'Edit group',
    deleteGroup: 'Delete group',
  },
  // 个人中心
  profile: {
    baseInfo: 'Basic Information',
    changePassword: 'Change password',
    updateCompleted: 'Update completed',
  },
  // 推送策略
  pushStrategy: {
    add: 'Add strategy',
    update: 'Update strategy',
    pushRuleTypes: {
      PushAdmACC: 'Push acceleration',
      PushAdmXYZ: 'Push coordinate observation value',
      PushAdmXYZChange: 'Change in push coordinates',
      PushAdmEN: 'Push northeast azimuth',
      PushGlodonValue: 'Glodon format Push (test)',
    },
    timeOptions: {
      300000: '5 minutes',
      600000: '10 minutes',
      1800000: '30 minutes',
      3600000: '1 hour',
      7200000: '2 hours',
    },
  },
  operationLog: {
    key: 'Keyword',
    keyP: 'Please input IP / UA',
    scope: 'Scope',
    scopeP: 'Please select scope',
    action: 'Action',
    actionP: 'Pleace select action',
    scopeId: 'Scope ID',
    ip: 'IP',
    ua: 'Client',
    content: 'Content',
  },
  protocols: {
    ADM: 'HS-ADM',
    HDA2: 'HS-HDA(frequency)',
    HDA3: 'HS-HDA(current)',
    HDA_HSL: 'HS-HDA(hydrostatic)',
    HDA_FLOW: 'HS-HDA(flow)',
    HDA_RAIN: 'HS-HDA（rainfall）',
    SDM: 'HS-SDM',
    GDM: 'HS-GDM（GNSS）',
    ROCTEC_ADM: 'ROCTEC_ADM',
    ROCTEC_HYDRO: 'ROCTEC_HYDRO',
    ROCTEC_STATION: 'ROCTEC_STATION',
    ROCTEC_ZCYL: 'ROCTEC_ZCYL',
    WHU_GNSS: 'WHU_GNSS',
    HSAPP_RDM: 'HSAPP_RDM',
    TGY_IDM: 'TGY_IDM',
    HYDRO: 'HYDRO',
    OTHER: 'OTHER',
  },
};
